export const SET_ADD_DRIVER_WALLET = 'SET_ADD_DRIVER_WALLET';

export const actionSetAddDriverWallet = wallet => ({
    type: SET_ADD_DRIVER_WALLET,
    payload: wallet
})
